import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export type SearchType = 'PAYMENT';

interface INotificationState {
  error: any;
  errorDialog: {
    code: string;
    title: string;
    message: string;
  }
}

const initialState: INotificationState = {
  error: null,
  errorDialog: null,
}

export const notificationSlice = createSlice({
  name: 'notification',
  initialState: initialState,
  reducers: {
    resetErrorDialog(state) {
      state.error = null;
      state.errorDialog = null;
    },
    setErrorDialog(state, payload) {
      state.error = payload.payload.message;
      state.errorDialog = {
        code: payload.payload.code,
        message: payload.payload.message,
        title: payload.payload.title,
      };
    },
  },
  extraReducers(builder) {
    return builder
  }
});

export const selectNotificationStore = () => (state: RootState) => {
  return state.notification;
};

export const {
  resetErrorDialog,
  setErrorDialog
} = notificationSlice.actions;

export default notificationSlice.reducer;
